import AffectationGate from '@/components/Affectations/AffectationGate';
import Layout from '@/components/Layout';
import AdminAffectationsPage from '@/pages/AdminAffectationsPage';
import IngestionsPage from '@/pages/IngestionsPage';
import DirectusCallbackPage from '@/pages/DirectusCallbackPage';
import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/LoginPage';
import NotFoundPage from '@/pages/NotFoundPage';
import OnboardingPage from '@/pages/OnboardingPage';
import ProfileAffectationsPage from '@/pages/ProfileAffectationsPage';
import SusPage from '@/pages/SusPage';
import ThesaurusPage from '@/pages/ThesaurusPage';
import UploadPage from '@/pages/UploadPage';
import { withLoginEnforced } from '@/shared/auth/oidc';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import AppMenuPage from '@/components/AppMenuPage/AppMenuPage';
import MenuNavigationBreadcrumb from '@/components/header/MenuNavigationBreadcrumb';
import HelpPage from '@/components/HelpPage/HelpPage';
import AdminGate from '@/components/Permissions/AdminGate';
import PermissionGate from '@/components/Permissions/PermissionGate';
import StatisticsRequestPage from '@/components/statisticResquest/StatisticsRequestPage';
import { routes as driveRoutes } from '@/modules/drive';

const ProtectedHomePage = withLoginEnforced(HomePage);
const ProtectedOnboardingPage = withLoginEnforced(OnboardingPage);
const ProtectedProfileAffectationsPage = withLoginEnforced(ProfileAffectationsPage);
const ProtectedAppMenuPage = withLoginEnforced(AppMenuPage);
const ProtectedHelpPage = withLoginEnforced(HelpPage);
const ProtectedStatisticsRequestPage = withLoginEnforced(StatisticsRequestPage);

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    handle: {
      breadcrumbKey: 'nav.home',
    },
    children: [
      {
        element: <AffectationGate />,
        children: [
          {
            index: true,
            element: <ProtectedHomePage />,
          },
          {
            path: 'page/:menuId',
            element: <ProtectedAppMenuPage />,
            handle: {
              breadcrumb: (match: { params: Record<string, string | undefined> }) => (
                <MenuNavigationBreadcrumb id={Number(match.params.menuId)} />
              ),
            },
          },
          {
            path: 'help-page',
            element: <ProtectedHelpPage />,
            handle: {
              breadcrumbKey: 'header.help',
            },
          },
          {
            path: 'statistics-request',
            element: <ProtectedStatisticsRequestPage />,
            handle: {
              breadcrumbKey: 'header.ask_for_stats',
            },
          },
          {
            path: 'profil/affectations',
            element: <ProtectedProfileAffectationsPage />,
            handle: {
              breadcrumbKey: 'nav.profil.affectations',
            },
          },
          {
            path: 'admin/affectations',
            element: (
              <AdminGate>
                <AdminAffectationsPage />
              </AdminGate>
            ),
            handle: {
              breadcrumbKey: 'nav.admin.affectations',
            },
          },
          {
            path: 'admin/ingestions',
            element: <IngestionsPage />,
            handle: {
              breadcrumbKey: 'nav.admin.ingestions',
            },
          },
          {
            path: 'sus',
            element: <SusPage />,
            handle: {
              breadcrumbKey: 'nav.admin.sus',
            },
          },
          {
            path: 'thesaurus',
            element: <ThesaurusPage />,
            handle: {
              breadcrumbKey: 'nav.thesaurus',
            },
          },
          {
            path: 'admin/sus',
            element: <Navigate to="/sus" replace />,
          },
        ],
      },
      {
        path: 'onboarding',
        element: <ProtectedOnboardingPage />,
        handle: {
          breadcrumbKey: 'nav.onboarding',
        },
      },
      {
        path: 'upload',
        element: (
          <PermissionGate requiredPermissions="deposit-oru-drive-files">
            <UploadPage />
          </PermissionGate>
        ),
        handle: {
          breadcrumbKey: 'upload.title',
        },
      },
      {
        path: 'login',
        element: <LoginPage />,
        handle: {
          breadcrumbKey: 'nav.login',
        },
      },
      ...driveRoutes,
    ],
  },
  {
    path: '/auth/directus-callback',
    element: <DirectusCallbackPage />,
  },
  { path: '*', element: <NotFoundPage /> },
]);

export default router;
